document.addEventListener("DOMContentLoaded", function () {
  const selectors = {
    thumbnailSlider: ".thumbnail-slider",
    thumbnailList: ".thumbnail-list",
    thumbnailItem: ".thumbnail-list__item:not(.hidden-by-variant)",
    thumbnailButton: ".thumbnail",
    arrowPrev: ".thumbnail-arrow-prev",
    arrowNext: ".thumbnail-arrow-next",
    sliderDot: ".slider-dot",
    mainList: ".product__media-list",
    mainItem: ".product__media-item",
  };

  let userMuted = null;

  // ==========================================================
  // [终极核心修复] 拦截底层组件原型，彻底免疫 Shopify AJAX 刷新！
  // 严格区分 PC 和 Mobile，精准分配目标图片。
  // ==========================================================
  function patchMediaGallery() {
    const MediaGalleryClass = customElements.get("media-gallery");
    // 如果没有找到组件，或者已经拦截过了，则退出
    if (!MediaGalleryClass || MediaGalleryClass.prototype.customPatched) return;

    // 保存 Dawn 原生的逻辑
    const originalSetActiveMedia = MediaGalleryClass.prototype.setActiveMedia;

    // 重写底层方法
    MediaGalleryClass.prototype.setActiveMedia = function (mediaId, prepend) {
      // 1. 判断当前设备（Dawn 的分界线是 750px）
      const isDesktop = window.matchMedia("(min-width: 750px)").matches;

      // 2. 验证图片是否在当前设备真正“合法可见”
      const isValidForCurrentDevice = (el) => {
        if (!el) return false;
        if (el.classList.contains("hidden-by-variant")) return false; // 排除属于其他变体的图

        if (isDesktop) {
          // PC端：排除带有移动端隐藏类的图
          if (
            el.classList.contains("medium-hide") ||
            el.classList.contains("large-up-hide")
          )
            return false;
        } else {
          // 移动端：排除带有PC端隐藏类的图
          if (el.classList.contains("small-hide")) return false;
        }
        return true;
      };

      // 3. 读取 Liquid 生成的重定向映射
      let redirectMap = {};
      const redirectMapStr = this.getAttribute("data-redirect-map");
      if (redirectMapStr) {
        redirectMapStr.split(",").forEach((pair) => {
          if (pair) {
            const parts = pair.split(":");
            if (parts.length === 2) redirectMap[parts[0]] = parts[1];
          }
        });
      }

      let targetMediaId = mediaId;
      for (const [featId, subId] of Object.entries(redirectMap)) {
        if (targetMediaId && targetMediaId.includes(featId)) {
          targetMediaId = targetMediaId.replace(featId, subId);
          break;
        }
      }

      let targetElement = this.querySelector(
        `[data-media-id*="${targetMediaId}"]`,
      );

      // 4. 核心拦截：如果是变体切换(prepend=true) 或 找到的图在当前设备不合法
      if (prepend || !isValidForCurrentDevice(targetElement)) {
        const allVariantItems = Array.from(
          this.querySelectorAll(".product__media-item:not(.hidden-by-variant)"),
        );

        // 关键：在当前变体下，精准找到第一张匹配当前设备的图！
        targetElement = allVariantItems.find(isValidForCurrentDevice);

        // 极端保底防错
        if (!targetElement && allVariantItems.length > 0) {
          targetElement = allVariantItems[0];
        }
      }

      if (targetElement) {
        const finalId =
          targetElement.getAttribute("data-media-id") || targetMediaId;
        // 5. 传回给原生逻辑，并强制关闭 prepend (避免 DOM 位移破坏视频)
        originalSetActiveMedia.call(this, finalId, false);
      }
    };

    // 标记已成功拦截
    MediaGalleryClass.prototype.customPatched = true;
  }

  // 执行原型拦截 (兼容组件晚加载的情况)
  if (customElements.get("media-gallery")) {
    patchMediaGallery();
  } else {
    customElements.whenDefined("media-gallery").then(patchMediaGallery);
  }
  // ==========================================================

  // ==========================================================
  // 下方保留缩略图轮播与视频控制逻辑
  // ==========================================================
  document.querySelectorAll(selectors.thumbnailSlider).forEach((slider) => {
    initThumbnailSlider(slider);
  });

  if (document.querySelectorAll(selectors.thumbnailSlider).length === 0) {
    const gallery = document.querySelector("media-gallery");
    if (gallery) initThumbnailSlider(gallery);
  }

  function initThumbnailSlider(container) {
    const mediaGallery =
      container.tagName === "MEDIA-GALLERY"
        ? container
        : container.closest("media-gallery");
    if (!mediaGallery) return;

    const thumbSlider = mediaGallery.querySelector(selectors.thumbnailSlider);
    const thumbList = thumbSlider
      ? thumbSlider.querySelector(selectors.thumbnailList)
      : null;
    const prevBtn = thumbSlider
      ? thumbSlider.querySelector(selectors.arrowPrev)
      : null;
    const nextBtn = thumbSlider
      ? thumbSlider.querySelector(selectors.arrowNext)
      : null;
    const mainListElement = mediaGallery.querySelector(selectors.mainList);
    const sliderDots = mediaGallery.querySelectorAll(selectors.sliderDot);

    let autoPlayTimer = null;
    let currentVideoElement = null;
    let videoEndHandler = null;
    let videoUpdateHandler = null;
    let isGalleryInView = true;
    let autoPlayStartTime = 0;
    let autoPlayRemainingTime = 6000;
    let isCurrentSlideVideo = false;

    function isElementVisible(el) {
      return (
        el &&
        (el.offsetWidth > 0 || el.offsetHeight > 0) &&
        el.offsetParent !== null
      );
    }

    function getVisibleThumbnails() {
      if (!thumbSlider || !isElementVisible(thumbSlider)) return [];
      return Array.from(
        thumbSlider.querySelectorAll(selectors.thumbnailItem),
      ).filter(isElementVisible);
    }

    function getVisibleMainSlides() {
      return Array.from(
        mediaGallery.querySelectorAll(selectors.mainItem),
      ).filter(
        (slide) =>
          !slide.classList.contains("hidden-by-variant") &&
          isElementVisible(slide),
      );
    }

    function getPureMediaId(element) {
      if (!element) return null;
      let id = element.dataset.mediaId;
      if (!id || /\D/.test(id)) {
        const innerWithId = element.querySelector("[data-media-id]");
        if (innerWithId) {
          const innerId = innerWithId.dataset.mediaId;
          if (innerId && /^\d+$/.test(innerId)) return innerId;
        }
        if (id && id.includes("-")) {
          const parts = id.split("-");
          return parts[parts.length - 1];
        }
      }
      return id;
    }

    function setVideoMode(thumbBtn, dotElem, isVideo) {
      if (thumbBtn) {
        thumbBtn.style.setProperty("--progress", "0%");
        if (isVideo) thumbBtn.classList.add("video-mode");
        else {
          thumbBtn.classList.remove("video-mode");
          thumbBtn.style.animation = "none";
          void thumbBtn.offsetHeight;
          thumbBtn.style.animation = "";
        }
      }
      if (dotElem) {
        dotElem.style.setProperty("--progress", "0%");
        if (isVideo) dotElem.classList.add("video-mode");
        else {
          dotElem.classList.remove("video-mode");
          const inner = dotElem.querySelector(".slider-dot__inner");
          if (inner) {
            inner.style.animation = "none";
            void inner.offsetHeight;
            inner.style.animation = "";
          }
        }
      }
    }

    function resetAllProgressStyles() {
      if (thumbSlider) {
        thumbSlider
          .querySelectorAll(selectors.thumbnailButton)
          .forEach((btn) => {
            btn.classList.remove("video-mode");
            btn.style.setProperty("--progress", "0%");
          });
      }
      sliderDots.forEach((dot) => {
        dot.classList.remove("video-mode");
        dot.style.setProperty("--progress", "0%");
      });
    }

    function handleMediaChange(targetMediaId, userTriggered = false) {
      clearTimeout(autoPlayTimer);
      if (currentVideoElement) {
        if (videoEndHandler)
          currentVideoElement.removeEventListener("ended", videoEndHandler);
        if (videoUpdateHandler)
          currentVideoElement.removeEventListener(
            "timeupdate",
            videoUpdateHandler,
          );
        try {
          currentVideoElement.pause();
        } catch (e) {}
      }
      currentVideoElement = null;

      let mainItem = null;
      if (targetMediaId) {
        const candidates = Array.from(
          mediaGallery.querySelectorAll(selectors.mainItem),
        );
        mainItem = candidates.find(
          (item) =>
            getPureMediaId(item) === targetMediaId && isElementVisible(item),
        );
      }

      if (!mainItem) {
        const activeItem = mediaGallery.querySelector(
          ".product__media-item.is-active",
        );
        if (activeItem && isElementVisible(activeItem)) mainItem = activeItem;
      }

      if (!mainItem) {
        const visibleSlides = getVisibleMainSlides();
        if (visibleSlides.length > 0) mainItem = visibleSlides[0];
      }

      if (!mainItem) return;

      mediaGallery
        .querySelectorAll(selectors.mainItem)
        .forEach((slide) => slide.classList.remove("is-active"));
      mainItem.classList.add("is-active");

      const currentPureId = getPureMediaId(mainItem);
      const currentRawId = mainItem.dataset.mediaId;

      let activeThumbBtn = null;
      resetAllProgressStyles();

      if (thumbSlider) {
        thumbSlider
          .querySelectorAll(selectors.thumbnailButton)
          .forEach((btn) => {
            const item = btn.closest("li");
            const itemMediaId = item.dataset.mediaId;
            const itemTarget = item.dataset.target;
            const isMatch =
              (itemMediaId && itemMediaId == currentPureId) ||
              (itemTarget && currentRawId && itemTarget === currentRawId) ||
              (itemTarget &&
                currentPureId &&
                itemTarget.includes(currentPureId));

            if (isMatch) {
              activeThumbBtn = btn;
              btn.setAttribute("aria-current", "true");
            } else {
              btn.setAttribute("aria-current", "false");
            }
          });
        scrollToActiveThumbnail();
      }

      syncDots(currentPureId);
      const activeDot = mediaGallery.querySelector(
        ".slider-dot.slider-dot--active",
      );

      const dataType = mainItem.dataset.mediaType;
      const containerDOM =
        mainItem.querySelector(".product-media-container") || mainItem;
      const hasVideoClass =
        containerDOM.classList.contains("media-type-video") ||
        mainItem.classList.contains("media-type-video") ||
        containerDOM.classList.contains("media-type-external_video");
      const deferredMedia =
        mainItem.querySelector("deferred-media") ||
        (mainItem.tagName === "DEFERRED-MEDIA" ? mainItem : null);
      const isVideo =
        dataType === "video" ||
        dataType === "external_video" ||
        hasVideoClass ||
        deferredMedia ||
        mainItem.querySelector("video") ||
        mainItem.querySelector("iframe");

      if (isVideo) {
        isCurrentSlideVideo = true;
        setVideoMode(activeThumbBtn, activeDot, true);
        if (deferredMedia) {
          const loadBtn =
            deferredMedia.querySelector(".deferred-media__poster") ||
            deferredMedia.querySelector("button") ||
            mainItem.querySelector(".product__media-toggle");
          if (loadBtn) {
            loadBtn.click();
            loadBtn.style.display = "none";
          }
        }
        waitForVideo(mainItem, (videoEl) => {
          if (videoEl)
            prepareAndPlayVideo(
              videoEl,
              activeThumbBtn,
              activeDot,
              !userTriggered,
            );
          else {
            isCurrentSlideVideo = false;
            setVideoMode(activeThumbBtn, activeDot, false);
            autoPlayStartTime = Date.now();
            autoPlayRemainingTime = 6000;
            autoPlayTimer = setTimeout(triggerNextSlide, 6000);
          }
        });
      } else {
        isCurrentSlideVideo = false;
        setVideoMode(activeThumbBtn, activeDot, false);
        autoPlayStartTime = Date.now();
        autoPlayRemainingTime = 6000;
        autoPlayTimer = setTimeout(triggerNextSlide, 6000);
      }
    }

    function waitForVideo(containerDOM, callback) {
      let attempts = 0;
      const check = setInterval(() => {
        attempts++;
        const video = containerDOM.querySelector("video");
        if (video) {
          clearInterval(check);
          callback(video);
        } else if (attempts >= 60) {
          clearInterval(check);
          callback(null);
        }
      }, 50);
    }

    function prepareAndPlayVideo(video, thumbBtn, dotElem, muted = false) {
      currentVideoElement = video;
      video.removeAttribute("controls");
      video.controls = false;
      video.autoplay = false;
      video.muted = userMuted !== null ? userMuted : muted;
      video.loop = false;
      video.playsInline = true;
      video.setAttribute("preload", "auto");

      const containerDOM = video.closest(".product__media-item");
      if (containerDOM) {
        containerDOM.classList.add("video-active");
        const controls = containerDOM.querySelector(".custom-video-controls");
        if (controls) {
          const playPauseBtn = controls.querySelector(".btn-play-pause");
          const muteBtn = controls.querySelector(".btn-mute-toggle");
          const iconPlay = playPauseBtn.querySelector(".icon-play");
          const iconPause = playPauseBtn.querySelector(".icon-pause");
          const iconMute = muteBtn.querySelector(".icon-volume-off");
          const iconSound = muteBtn.querySelector(".icon-volume-on");

          const updatePlayPauseUI = () => {
            if (video.paused) {
              iconPlay.classList.remove("hidden");
              iconPause.classList.add("hidden");
            } else {
              iconPlay.classList.add("hidden");
              iconPause.classList.remove("hidden");
            }
          };

          const updateMuteUI = () => {
            if (video.muted) {
              iconMute.classList.remove("hidden");
              iconSound.classList.add("hidden");
            } else {
              iconMute.classList.add("hidden");
              iconSound.classList.remove("hidden");
            }
          };

          playPauseBtn.onclick = (e) => {
            e.stopPropagation();
            video.paused ? video.play() : video.pause();
          };
          muteBtn.onclick = (e) => {
            e.stopPropagation();
            userMuted = !video.muted;
            video.muted = !video.muted;
          };

          video.onplay = updatePlayPauseUI;
          video.onpause = updatePlayPauseUI;
          video.onvolumechange = updateMuteUI;
          updatePlayPauseUI();
          updateMuteUI();
        }
      }

      videoEndHandler = () => triggerNextSlide();
      video.addEventListener("ended", videoEndHandler);
      videoUpdateHandler = () => {
        if (video.duration > 0) {
          const progressStyle = `${(video.currentTime / video.duration) * 100}%`;
          if (thumbBtn) thumbBtn.style.setProperty("--progress", progressStyle);
          if (dotElem) dotElem.style.setProperty("--progress", progressStyle);
        }
      };
      video.addEventListener("timeupdate", videoUpdateHandler);

      setTimeout(() => {
        if (currentVideoElement !== video) return;
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch((error) => {
            if (error.name === "NotAllowedError" && !video.muted) {
              video.muted = true;
              video.play().catch(() => {});
            } else if (error.name !== "AbortError") {
              isCurrentSlideVideo = false;
              setVideoMode(thumbBtn, dotElem, false);
              autoPlayStartTime = Date.now();
              autoPlayRemainingTime = 6000;
              autoPlayTimer = setTimeout(triggerNextSlide, 6000);
            }
          });
        }
      }, 150);
    }

    function triggerNextSlide(userTriggered = false) {
      if (!isGalleryInView && !userTriggered) return;
      const visibleThumbs = getVisibleThumbnails();
      if (visibleThumbs.length > 1) {
        const currentActiveBtn = thumbSlider.querySelector(
          `${selectors.thumbnailButton}[aria-current="true"]`,
        );
        let currentIndex = currentActiveBtn
          ? visibleThumbs.indexOf(currentActiveBtn.closest("li"))
          : -1;
        let nextIndex = currentIndex + 1;
        if (nextIndex >= visibleThumbs.length) nextIndex = 0;
        const nextBtnElement = visibleThumbs[nextIndex].querySelector(
          selectors.thumbnailButton,
        );
        if (nextBtnElement) {
          nextBtnElement.click();
          setTimeout(() =>
            handleMediaChange(
              nextBtnElement.closest("li").dataset.mediaId,
              userTriggered,
            ),
          );
        }
      } else {
        const visibleSlides = getVisibleMainSlides();
        if (visibleSlides.length <= 1) return;
        const currentActive = mediaGallery.querySelector(
          ".product__media-item.is-active",
        );
        let next = visibleSlides.indexOf(currentActive) + 1;
        if (next >= visibleSlides.length) next = 0;
        if (visibleSlides[next]) performSlideSwitch(visibleSlides[next]);
      }
    }

    function triggerPrevSlide(userTriggered = false) {
      const visibleThumbs = getVisibleThumbnails();
      if (visibleThumbs.length > 1) {
        const currentActiveBtn = thumbSlider.querySelector(
          `${selectors.thumbnailButton}[aria-current="true"]`,
        );
        let currentIndex = currentActiveBtn
          ? visibleThumbs.indexOf(currentActiveBtn.closest("li"))
          : -1;
        let prevIndex = currentIndex - 1;
        if (prevIndex < 0) prevIndex = visibleThumbs.length - 1;
        const prevBtnElement = visibleThumbs[prevIndex].querySelector(
          selectors.thumbnailButton,
        );
        if (prevBtnElement) {
          prevBtnElement.click();
          setTimeout(() =>
            handleMediaChange(
              prevBtnElement.closest("li").dataset.mediaId,
              userTriggered,
            ),
          );
        }
      } else {
        const visibleSlides = getVisibleMainSlides();
        if (visibleSlides.length <= 1) return;
        const currentActive = mediaGallery.querySelector(
          ".product__media-item.is-active",
        );
        let prev = visibleSlides.indexOf(currentActive) - 1;
        if (prev < 0) prev = visibleSlides.length - 1;
        if (visibleSlides[prev]) performSlideSwitch(visibleSlides[prev]);
      }
    }

    function performSlideSwitch(targetSlide) {
      if (mainListElement)
        mainListElement.scrollTo({
          left: targetSlide.offsetLeft,
          behavior: "smooth",
        });
      handleMediaChange(getPureMediaId(targetSlide));
    }

    if (thumbSlider) {
      thumbSlider.querySelectorAll(selectors.thumbnailButton).forEach((btn) => {
        btn.addEventListener("click", (e) => {
          resetAllProgressStyles();
          if (e.isTrusted)
            handleMediaChange(btn.closest("li").dataset.mediaId, true);
        });
      });
    }

    if (nextBtn)
      nextBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        triggerNextSlide(true);
      });
    if (prevBtn)
      prevBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        triggerPrevSlide(true);
      });

    function scrollToActiveThumbnail() {
      if (!thumbSlider || !thumbList) return;
      const activeBtn = thumbSlider.querySelector('[aria-current="true"]');
      if (activeBtn && isElementVisible(activeBtn)) {
        thumbList.scrollTo({
          left: activeBtn.closest("li").offsetLeft,
          behavior: "smooth",
        });
      }
    }

    function syncDots(mediaId) {
      if (sliderDots.length === 0) return;
      const targetIndex = getVisibleMainSlides().findIndex(
        (slide) => getPureMediaId(slide) == mediaId,
      );
      if (targetIndex >= 0) {
        sliderDots.forEach((dot, idx) => {
          if (idx === targetIndex) {
            dot.classList.add("slider-dot--active");
            dot.setAttribute("aria-current", "true");
          } else {
            dot.classList.remove("slider-dot--active");
            dot.setAttribute("aria-current", "false");
          }
        });
      }
    }

    const mainSliderComponent = mediaGallery.querySelector(
      "product-media-slider",
    );
    if (mainSliderComponent) {
      mainSliderComponent.addEventListener("slideChanged", (event) => {
        const activeElement = event.detail.currentElement;
        if (activeElement) handleMediaChange(getPureMediaId(activeElement));
      });
    }

    if (mainListElement) {
      let scrollTimeout;
      mainListElement.addEventListener(
        "scroll",
        () => {
          clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(() => {
            const center =
              mainListElement.scrollLeft + mainListElement.offsetWidth / 2;
            const slides = getVisibleMainSlides();
            let closest = null;
            let minDiff = Infinity;
            slides.forEach((slide) => {
              const diff = Math.abs(
                center - (slide.offsetLeft + slide.offsetWidth / 2),
              );
              if (diff < minDiff) {
                minDiff = diff;
                closest = slide;
              }
            });
            if (closest) {
              const currentActive = mediaGallery.querySelector(
                ".product__media-item.is-active",
              );
              if (closest !== currentActive)
                handleMediaChange(getPureMediaId(closest));
            }
          }, 100);
        },
        { passive: true },
      );
    }

    const keepEnabled = (btn) => {
      if (!btn) return;
      btn.removeAttribute("disabled");
      new MutationObserver((mutations) => {
        mutations.forEach((m) => {
          if (
            m.type === "attributes" &&
            m.attributeName === "disabled" &&
            btn.hasAttribute("disabled")
          ) {
            btn.removeAttribute("disabled");
          }
        });
      }).observe(btn, { attributes: true });
    };
    keepEnabled(prevBtn);
    keepEnabled(nextBtn);

    const galleryObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const wasInView = isGalleryInView;
          isGalleryInView = entry.isIntersecting;
          if (!isGalleryInView && wasInView) {
            clearTimeout(autoPlayTimer);
            if (!isCurrentSlideVideo) {
              autoPlayRemainingTime = Math.max(
                0,
                6000 - (Date.now() - autoPlayStartTime),
              );
            }
            if (
              isCurrentSlideVideo &&
              currentVideoElement &&
              !currentVideoElement.paused
            ) {
              try {
                currentVideoElement.pause();
              } catch (e) {}
            }
            mediaGallery.classList.add("autoplay-paused");
          } else if (isGalleryInView && !wasInView) {
            mediaGallery.classList.remove("autoplay-paused");
            if (isCurrentSlideVideo) {
              if (currentVideoElement && currentVideoElement.paused) {
                const p = currentVideoElement.play();
                if (p) p.catch(() => {});
              }
            } else {
              autoPlayStartTime = Date.now();
              autoPlayTimer = setTimeout(
                triggerNextSlide,
                autoPlayRemainingTime,
              );
            }
          }
        });
      },
      { threshold: 0 },
    );
    galleryObserver.observe(mediaGallery);

    setTimeout(() => {
      const activeMedia = mediaGallery.querySelector(
        ".product__media-item.is-active",
      );
      if (activeMedia && isElementVisible(activeMedia))
        handleMediaChange(getPureMediaId(activeMedia));
      else {
        const visibleSlides = getVisibleMainSlides();
        if (visibleSlides.length > 0) performSlideSwitch(visibleSlides[0]);
      }
    }, 100);
  }
});
